import React from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <div></div>
            </components.DropdownIndicator>
        )
    );
};

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderWidth: 1,
        borderColor: "#d6d6d6",
        boxShadow: state.isFocused ? "0 0 1px #fc8093" : "none",
        backgroundColor: "#fff",
        borderRadius: 0,
        height: 57,
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingLeft: 17,
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: 14,
        color: "#303030",
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: 14,
        color: "#2c2c2c",
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
    }),
    dropdownIndicator: () => ({
        marginTop: "-8px",
        marginRight: 18,
        boxSizing: "border-box",
        height: "13px",
        width: "13px",
        borderStyle: "solid",
        borderColor: "#2c2c2c",
        borderWidth: "0px 1px 1px 0px",
        transform: "rotate(45deg)",
        transition: "border-width 150ms ease-in-out",
    }),
    menu: () => ({
        top: "100%",
        width: "100%",
        position: "absolute",
        zIndex: 1,
        background: "#fafafa",
    }),
    menuList: (provided) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    option: (provided, state) => ({
        ...provided,
        padding: 12,
        fontSize: 14,
        color: state.isFocused ? "#fff" : "#2c2c2c",
        backgroundColor: state.isFocused ? "#fc8093" : "none",
        "&:hover": {
            backgroundColor: "#fc8093",
            color: "#fff",
        },
    }),
};

export const reviewSortOptions = [
    { value: "desc", label: "Newest First" },
    { value: "asc", label: "Oldest First" },
];

const ReviewSort = (props) => {
    const { id, value, onChange } = props;

    return (
        <>
            <Select
                value={value}
                components={{ DropdownIndicator }}
                onChange={onChange}
                options={reviewSortOptions}
                instanceId={id}
                isSearchable={false}
                styles={customStyles}
            />
        </>
    );
};

ReviewSort.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ReviewSort;
